import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';
import {
    ListView,
    ScreeningDetailView,
    ScreeningHistoryItem,
    ScreeningLocationDetailView,
    ScreeningResultDetailView,
    ScreeningResultHistoryItem
} from '../contracts';
@Injectable()
export class ScreeningService {

    constructor(private readonly http: HttpClient) { }

    public getScreeningResultHistories(criteria: any): Observable<ListView<ScreeningResultHistoryItem>> {
        const url = AppConfig.apiUrls.screenings.getScreeningResultHistories(criteria.locationId);
        const params = new HttpParams()
            .set('polygonType', criteria.polygonType || criteria.polygonType === 0 ? criteria.polygonType : '')
            .set('polygonArea', criteria.polygonArea ? criteria.polygonArea : '');
        return this.http.get<ListView<ScreeningResultHistoryItem>>(url, { params });
    }

    public getScreeningHistories(criteria: any): Observable<ListView<ScreeningHistoryItem>> {
        const url = AppConfig.apiUrls.screenings.getScreeningHistories(criteria.locationId);

        return this.http.get<ListView<ScreeningHistoryItem>>(url);
    }

    public getScreeningResultDetails(id: string): Observable<ScreeningResultDetailView> {
        const url = AppConfig.apiUrls.screenings.getResultDetails(id);
        return this.http.get<ScreeningResultDetailView>(url);
    }

    public getLocationDetails(id: string): Observable<ScreeningLocationDetailView> {
        const url = AppConfig.apiUrls.screenings.getLocationDetails(id);
        return this.http.get<ScreeningLocationDetailView>(url);
    }

    public getScreeningDetails(id: string): Observable<ScreeningDetailView> {
        const url = AppConfig.apiUrls.screenings.getById(id);
        return this.http.get<ScreeningDetailView>(url);
    }
}
